import { BrowserRouter as Router, Route, Switch, useLocation, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import {Progress, ChakraProvider, Center, Circle, Link, Box, Heading, Text, theme, VStack, HStack, Card, CardBody, Stack, Divider, Button, CardFooter } from '@chakra-ui/react';
import firebase from 'firebase/app';
import { auth, db } from "../firebase-config";
import { ArrowBackIcon } from '@chakra-ui/icons';
import {collectionGroup, collection, query, getDocs, where, orderBy, documentId} from 'firebase/firestore';
import BarChart from "../components/barChart";
import BarChartDiff from "../components/barChartDiff";
import { CategoryScale } from "chart.js";
import Chart from "chart.js/auto";
import { FaStar } from 'react-icons/fa';
import { Filter } from 'bad-words';


const colors = ["red", "orange", "yellow", "lightGreen", "green"];
const colorsOpp = ["green", "lightGreen", "yellow", "orange", "red"];
const finals = ["Exam", "Project", "Paper", "Presentation", "None", "Other"];
const grades = ["No Grade Received", "A", "A-", "B+", "B", "B-", "C+", "C", "C-", "D+", "D", "D-", "F", "W", "I"];
const attendance = ["Mandatory", "Optional", "Sometimes"];
const options = { year: 'numeric', month: 'long', day: 'numeric' };

export default function CoursePage() {
  var Filter = require('bad-words'), filter = new Filter();
  document.body.style.background = 'lightyellow';
  const location = useLocation();
  const pathArray = location.pathname.split('/');
  const department = pathArray[2];
  const courseCode = pathArray[3];
  Chart.register(CategoryScale);

  const [departmentDocID, setDepartmentDocID] = useState("");
  const [postLists, setPostList] = useState([]);
  const [departmentName, setDepartmentName] = useState(department);
  const [departmentCode, setDepartmentCode] = useState("");
  const [courseReviews, setCourseReviews] = useState([]);
  const [diffCourseReviews, setDiffCourseReviews] = useState([]);
  const [timeStamp, setTimeStamp] = useState("");

  let navigate = useNavigate();
    const RouteChange = () =>{
    let path = '/not-found';    
    navigate(path);
  }

  useEffect(() => {
    document.body.style.background = 'lightyellow';
    const searchQuery = async () => {
      const q = query(collection(db, "departments"), where("deptCode", "==", department));
      const querySnapshot = await getDocs(q);
      if (querySnapshot.size === 0) {
          
        RouteChange();
      } else {
        querySnapshot.forEach((doc) => {
          setDepartmentDocID(doc.id);
          setDepartmentName(doc.data()['deptName']);
          setDepartmentCode(doc.data()['deptCode']);
        });
        const c = query(collection(db, `departments/${departmentDocID}/courses`), where("courseNum", "==", courseCode));
        const data = await getDocs(c);
        if (data.size === 0) {
            
          RouteChange();
        } else {
          var posts = [];
          let ratings = [];
          let time = new Date();
          
          data.forEach((doc) => {
            const review = doc.data()['review'];
            ratings[review - 1]++;
            time = new Date(doc.data()['timestamp']).getTime();
            const timestamp = Date.parse(doc.data()['timestamp']);
            posts.push({
              departmentCode: doc.data()['departmentCode'],
              courseNum: doc.data()['courseNum'],
              review: review,
              qualityRating: doc.data()['qualityRating'],
              profName: doc.data()['profName'],
              grade: doc.data()['grade'],
              userMajor: doc.data()['userMajor'],
              finalType: doc.data()['finalType'],
              difficultyRating: doc.data()['diffRating'],
              attendance: doc.data()["attendance"],
              timestamp: timestamp,
              date: new Date(timestamp).toLocaleDateString(undefined, options)
            });
          });
          // sort posts array in descending order based on timestamp
          const sortedPosts = [...posts].sort((a, b) => b.timestamp - a.timestamp);
          console.log(sortedPosts);
          
          setPostList(sortedPosts);
          setChartData((prevState) => {
            return {
              ...prevState,
              datasets: [
                {
                  ...prevState.datasets[0],
                  data: [...ratings]
                }
              ]
            };
          });
          setChartDiff((prevState) => {
            return {
              ...prevState,
              datasets: [
                {
                  ...prevState.datasets[0],
                  data: [...ratings]
                }
              ]
            };
          });
        }
      }
    };
    searchQuery();
  },[departmentDocID, courseCode]);

useEffect(() => {
  const fetchCourseReviews = async () => {
    const q = query(collection(db, `departments/${departmentDocID}/courses`), where("courseNum", "==", courseCode));
    const querySnapshot = await getDocs(q);
    const reviews = [];
    const reviewsDiff = [0,0,0,0,0];
    querySnapshot.forEach((doc) => {
      reviews.push(doc.data().qualityRating);
      reviewsDiff.push(doc.data().diffRating);
    });
    setCourseReviews(reviews);
    setDiffCourseReviews(reviewsDiff);
  };
  fetchCourseReviews();
}, [departmentDocID, courseCode]);

useEffect(() => {
  if (courseReviews.length > 0) {
    const countReviews = (data) => {
      const count = [0, 0, 0, 0, 0];
      for (let i = 0; i < data.length; i++) {
        count[data[i] - 1]++;
      }
      return count;
    };

    const count = countReviews(courseReviews);
      setChartData({
        labels: ['Horrible (1)','Bad (2)','Okay (3)','Great (4)','Amazing (5)'],
        datasets: [
          {
            label: "Total Reviews",
            data: count,
            backgroundColor: colors,
            borderColor: "black",
            borderWidth: 2
          }
        ]
      });
    }
  }, [courseReviews]);

const [chartData1, setChartData] = useState({
  labels: ['Horrible (1)','Bad (2)','Okay (3)','Great (4)','Amazing (5)'],

  datasets: [
    {
      label: "Total Reviews",
      data: [], // Initializing data property to an empty array
      backgroundColor: [
        "red",
        "orange",
        "yellow",
        "lightgreen",
        "green"
      ],
      borderColor: "black",
      borderWidth: 2
    }
  ]
},[]);


useEffect(() => {
  if (diffCourseReviews.length > 0) {
    const countReviews2 = (data) => {
      const count = [0, 0, 0, 0, 0];
      for (let i = 0; i < data.length; i++) {
        count[data[i] - 1]++;
      }
      return count;
    };

    const count = countReviews2(diffCourseReviews);
      setChartDiff({
        labels: ['Easy (1)','Managable (2)','Okay (3)','Hard (4)','Impossible (5)'],
        datasets: [
          {
            label: "Total Reviews",
            data: count,
            backgroundColor: colorsOpp,
            borderColor: "black",
            borderWidth: 2
          }
        ]
      });
    }
  }, [diffCourseReviews]);

const [chartDiff, setChartDiff] = useState({
  labels: ['Easy (1)','Managable (2)','Okay (3)','Hard (4)','Impossible (5)'],

  datasets: [
    {
      label: "Total Reviews",
      data: [],
      backgroundColor: [
        "green",
        "lightgreen",
        "yellow",
        "orange",
        "red"
      ],
      borderColor: "black",
      borderWidth: 2
    }
  ]
},[]);

  return (
    <ChakraProvider theme={theme}>
      <Box>
      <Link href={`/departments/${departmentCode}`}>  
        <HStack>
          <ArrowBackIcon size= "20px" color = 'black'>
          </ArrowBackIcon>
          <Text size= "30px" color = 'black' as='b'>Back</Text>
        </HStack>     
        </Link>
      </Box>
      <VStack spacing="20px" alignItems= 'stretch'>
        <Box width="5px" textAlign="center" fontSize="7xl"/>
        <Stack space={3} alignItems='center'>
          <VStack spacing="20px">
          
        <Heading as='h1' color='black'>
        
                <div style={{ 
                  fontFamily: 'Helvetica Neue',
                  WebkitTextFillColor: 'black', // for Safari
                  textFillColor: 'black',
                  
                  }}>
                  <Text as='em'>
                    {departmentName}
                    {'  '}
                    {courseCode}
                  </Text> 
                </div>
             
                  
        </Heading>
      <HStack spacing = "40px" alignItems='center'>
        <Center>
        <BarChart chartData={chartData1} />
        </Center>
        <Center>
        <BarChartDiff chartData={chartDiff} />
        </Center>
      </HStack>
      </VStack>
      </Stack>
      {postLists.map((item) => (
          <VStack spacing="10px" >
            <Card width='1000px' style={{backgroundColor: '#ffd966'}}  variant='filled'>
              <CardBody>
                <Stack alignItems='center'>
                  <HStack >
                    <Text color= 'slategrey' fontSize="50px" > " </Text>
                    <Text  textAlign="center" color= 'slategrey' as='i'> {filter.clean(item['review'])}</Text>
                    <Text color= 'slategrey' fontSize="50px"> " </Text>
                  </HStack>
                </Stack>
              </CardBody>
              <Divider />
              <CardFooter>
                <HStack spacing= "25px" align ='left' >
                  <HStack spacing="5px" align ='left' > 
                    <Text fontSize='sm'>Professor: </Text>
                    <Text fontSize='sm' as='b'> {filter.clean(item['profName'])} </Text>
                  </HStack>

                  <HStack spacing="5px" align ='left' > 
                    <Text fontSize='sm'>Final Type: </Text>
                    <Text fontSize='sm' as='b'> {finals[item['finalType']-1]} </Text>
                  </HStack>

                  <HStack spacing="5px" align ='left' > 
                    <Text fontSize='sm'>Attendance: </Text>
                    <Text fontSize='sm' as='b'>{attendance[item['attendance']-1]} </Text>
                  </HStack>
      
                  <HStack spacing="5px" align ='left' > 
                    <Text fontSize='sm'>Grade: </Text>
                    <Text fontSize='sm' as='b'>{grades[item['grade']-1]} </Text>
                  </HStack> 
                
                  <HStack spacing="5px" align ='left' > 
                    <Text fontSize='sm'>Major: </Text>
                    <Text fontSize='sm' as='b'>{filter.clean(item['userMajor'])} </Text>
                  </HStack>
          
                </HStack>
              </CardFooter>
              <HStack spacing="30px">
              <VStack></VStack>
              <VStack>
                <Box position="relative" width="50px" height="50px">
                  <FaStar size="60px" color={colors[item['qualityRating']-1]} />
                  <Text
                    position="absolute"
                    top="60%"
                    left="60%"
                    transform="translate(-50%, -50%)">
                    {item['qualityRating']}
                  </Text>
                </Box>
                <Text as="i">Quality</Text>
              </VStack>
              <VStack>
                <Box position="relative" width="50px" height="50px">
                  <FaStar size="60px" color={colorsOpp[item['difficultyRating']-1]}/>
                  <Text
                    position="absolute"
                    top="60%"
                    left="60%"
                    transform="translate(-50%, -50%)"
                  >
                    {item['difficultyRating']}
                  </Text>
                </Box>
                <Text as="i">Difficulty</Text>
              </VStack>
              </HStack>
              <HStack spacing="5px" justifyContent="space-between" alignItems="center"> 
                    <Text fontSize='sm'> </Text>
                    <Text fontSize='md' as='i' color='grey'> {item['date']} </Text>
            </HStack>
            </Card>
          </VStack>
        ))}
      </VStack>
    </ChakraProvider>
  );
  }

 